import { galerij } from "../../data/content";

export const Galerij = () => {
  return (
    <section data-testid="galerij-section" className="py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mb-12">
          <span className="text-primary font-semibold text-sm uppercase tracking-wide">Sfeerimpressie</span>
          <h2 className="font-heading text-3xl md:text-4xl font-semibold tracking-tight mt-3">
            Een indruk van de locatie
          </h2>
          <p className="mt-4 text-lg text-muted-foreground leading-relaxed">
            Beelden van de zaal, de tafelopstelling en gezellige bijeenkomsten.
          </p>
        </div>

        <div className="columns-2 md:columns-3 gap-4 space-y-4">
          {galerij.map((g, i) => (
            <img
              key={i}
              data-testid={`galerij-foto-${i}`}
              src={g.url}
              alt={g.alt}
              className="w-full rounded-2xl object-cover break-inside-avoid hover:opacity-95 transition-opacity"
            />
          ))}
        </div>
      </div>
    </section>
  );
};
